export const PACKAGE_VERSION = '1.11.1'
